// Firebase and Brevo Credentials - Loaded from Environment Variables
// These values are set during build time and not exposed in the deployed code

export const Credentials = {
    // Firebase Configuration
    FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY || "",
    FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
    FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
    FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
    FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
    FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID || "",
    FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "",
    
    // Client Configuration (Multi-tenant structure)
    CLIENT_ID: import.meta.env.VITE_CLIENT_ID || "roadymalveira",
    
    // Brevo Configuration
    // Note: BREVO_API_KEY and BREVO_SMTP_LOGIN are now stored in Firebase Functions config (server-side only)
    // These sensitive credentials are no longer exposed in the frontend
    BREVO_SMTP_SERVER: import.meta.env.VITE_BREVO_SMTP_SERVER || "",
    BREVO_SMTP_PORT: parseInt(import.meta.env.VITE_BREVO_SMTP_PORT || "587"),
    BREVO_FROM_EMAIL: import.meta.env.VITE_BREVO_FROM_EMAIL || "",
    BREVO_FROM_NAME: import.meta.env.VITE_BREVO_FROM_NAME || "",
    BREVO_TO_EMAIL: import.meta.env.VITE_BREVO_TO_EMAIL || "",
    
    // reCAPTCHA Configuration
    RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || ""
};

export default Credentials;

